import { AxiosRequestConfig, AxiosResponse } from "axios";
import { Api } from "./Api";
import { apiConfig } from "../config/apiConfig";
import { dataURLtoFile } from "../utils/dataConverter";

class SignatureApi extends Api {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig);
  }

  public signCertificate = async (payload: string) => {
    const formData = new FormData();
    formData.set("timestamp", String(Date.now()));
    formData.set("file", dataURLtoFile(payload, 'Signature.png'));
    return await this.post("/esign", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((response: AxiosResponse) => response);
  }
  
}

export const signatureApi = new SignatureApi(apiConfig);
